<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowTestRunDetailsPopup"  persistent max-width="70%" class="popup-scoring" id="close-upload-popup">
                <v-card class="popup-scoring">
                    <v-card-title class="headline">
                        <span class="font-weight-light">Test Run Details</span>
                        <span  @click="hideTestPopup()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></span>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row justify-space-around v-if="testRunDetails">
                            <v-flex xs5>
                                <v-text-field placeholder="product code" v-model="testRunDetails.productCode"></v-text-field>
                                <v-text-field placeholder="application url" v-model="testRunDetails.applicationUrl"></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field placeholder="password" v-model="testRunDetails.password"></v-text-field>
                                <v-text-field placeholder="username" v-model=testRunDetails.username></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row justify-space-around v-if="!testRunDetails">
                            <p>No data available</p>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="provideDetails" class="btn-test-pg">{{text("api.button.ok")}}</v-btn>
                        <v-btn @click="hideTestPopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import axios from 'axios/dist/axios';

    export default {
        name: 'TestDetails',
        data () {
            return {
                uploadTrue: false
            }
        },
        computed: {
            ...mapGetters({
                mustShowTestRunDetailsPopup: 'TestStore/getMustShowTestRunDetailsPopup',
                testRunDetails: 'TestStore/getTestRunDetails'
            }),
        },
        methods: {
            ...mapActions({
                showTestPopup: 'TestStore/showTestPopup',
                testRunDetailsData: 'TestStore/testRunDetailsData'
            }),

            hideTestPopup() {
                this.$store.commit('TestStore/setMustShowTestRunDetailsPopup', false);
            },
            escapeKeyListener: function(evt) {
                if (evt.keyCode === 27) {
                    this.hideTestPopup();
                }
            },
            provideDetails() {
                console.log("sent ok")

                    let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/provideTestRunDetails', {
                        productCode: this.testRunDetails.productCode,
                        applicationUrl: this.testRunDetails.applicationUrl,
                        username: this.testRunDetails.username,
                        password: this.testRunDetails.password
                    });
                    axiosRequest.then((response) => {
                        console.log(response.data.returnCode);


                    });
                    axiosRequest.catch((error) => {
                        console.log(error);
                    });

            }

        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListener);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListener);
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .popup-scoring {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                padding: 15px 40px;
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/professional/components/tests/UploadTestRunDetailsPopup.vue